import { __extends } from "tslib";
import { KeyCode } from '@cseo/coherence-utilities';
import { classNamesFunction, Icon, IconButton, Link, Persona, PersonaPresence, PersonaSize, Stack, Text } from '@fluentui/react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import innerText from 'react-innertext';
dayjs.extend(duration);
dayjs.extend(localizedFormat);
var MAX_MESSAGE_CHARACTER = 200;
var CoherenceNotificationItemBase = (function (_super) {
    __extends(CoherenceNotificationItemBase, _super);
    function CoherenceNotificationItemBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getClassNames = classNamesFunction();
        _this._getId = function (identifier) {
            return ('coher-notificationItem-' +
                identifier +
                '-id-' +
                _this.props.item.itemKey);
        };
        _this._openNotificationItem = function (item) {
            var _a = _this.props, openItem = _a.openItem, onSetCurrentNotificationItem = _a.onSetCurrentNotificationItem;
            if (onSetCurrentNotificationItem) {
                onSetCurrentNotificationItem(item);
            }
            _this._updateNotificationItem(item.itemKey, 'old', 'read');
            if (openItem) {
                openItem(item.itemKey);
            }
        };
        _this._getTimeStamp = function (deliveredTime) {
            var _a, _b;
            var MDYYFormat = 'M/D/YY';
            var _c = _this.props, dateFormatter = _c.dateFormatter, timeFormatter = _c.timeFormatter;
            var start = dayjs(dayjs().format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat));
            var end = dayjs(deliveredTime.format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat));
            var timeDiff = dayjs.duration(start.diff(end)).asDays();
            if (timeDiff === 0) {
                return deliveredTime.format(timeFormatter !== null && timeFormatter !== void 0 ? timeFormatter : 'LT');
            }
            else if (timeDiff === 1) {
                return (_b = (_a = _this.props.timeGroupLabels) === null || _a === void 0 ? void 0 : _a.yesterday) !== null && _b !== void 0 ? _b : 'yesterday';
            }
            else {
                return deliveredTime.format(dateFormatter !== null && dateFormatter !== void 0 ? dateFormatter : MDYYFormat);
            }
        };
        _this._updateNotificationItem = function (itemKey, displayStatus, readStatus) {
            var updateItem = _this.props.updateItem;
            if (updateItem) {
                if (readStatus) {
                    updateItem(itemKey, displayStatus, readStatus);
                }
                else {
                    updateItem(itemKey, displayStatus);
                }
            }
        };
        _this._actionTextClicked = function (event) {
            event.stopPropagation();
        };
        _this._trimMessageBodyText = function (message) {
            var messageText = innerText(ReactHtmlParser(message));
            return messageText.length > MAX_MESSAGE_CHARACTER ? messageText.substring(0, MAX_MESSAGE_CHARACTER) : messageText;
        };
        return _this;
    }
    CoherenceNotificationItemBase.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props, styles = _h.styles, theme = _h.theme, notificationDismissedMessage = _h.notificationDismissedMessage, itemActionsText = _h.itemActionsText;
        var _classNames = this._getClassNames(styles, { theme: theme });
        var item = this.props.item;
        if (item.displayStatus === 'dismiss') {
            return (React.createElement(Stack, { className: _classNames.itemDismissUndo },
                React.createElement("div", { className: _classNames.attentionText }, notificationDismissedMessage !== null && notificationDismissedMessage !== void 0 ? notificationDismissedMessage : 'This notification has been dismissed'),
                React.createElement(Link, { className: _classNames.attentionText, href: '#', onClick: function () {
                        return _this._updateNotificationItem(item.itemKey, 'old');
                    } }, "Undo")));
        }
        var subjectTextStyle = item.status === 'unread'
            ? _classNames.subjectTextUnread
            : _classNames.subjectTextRead;
        var senderNameStyle = item.status === 'unread'
            ? _classNames.senderNameUnread
            : _classNames.senderNameRead;
        var timeDeliveredStyle = item.status === 'unread'
            ? _classNames.timeDeliveredUnread
            : _classNames.timeDeliveredRead;
        var _statusId = this._getId('status');
        var _senderNameId = this._getId('senderName');
        var _subjectId = this._getId('subject');
        return (React.createElement("div", { className: _classNames.root, role: 'presentation' },
            React.createElement("div", { id: this._getId('buttonDiv'), tabIndex: 0, "aria-labelledby": _statusId + ' ' + _senderNameId + ' ' + _subjectId, className: _classNames.rootButtonDiv, onClick: function () { return _this._openNotificationItem(item); }, onKeyPress: function (event) {
                    var code = event.keyCode || event.which;
                    if (code === KeyCode.Enter || code === KeyCode.Space) {
                        _this._openNotificationItem(item);
                    }
                } },
                React.createElement("div", { className: _classNames.buttonContent },
                    React.createElement(Stack, { horizontal: true },
                        React.createElement("div", { id: _statusId, "aria-label": item.status, className: _classNames.leftColumn, role: 'img' }, item.status === 'unread' && (React.createElement(Icon, { className: _classNames.unreadIcon, iconName: 'StatusCircleInner' }))),
                        React.createElement(Stack, { className: _classNames.timestampRow, horizontal: true },
                            item.senderName != null && (React.createElement(Persona, { className: _classNames.senderImage, imageUrl: item.senderImageUrl, presence: PersonaPresence.none, size: PersonaSize.size28, text: item.senderName })),
                            React.createElement(Stack, { className: _classNames.subjectContainer },
                                item.senderName != null && (React.createElement(Text, { id: _senderNameId, className: senderNameStyle, nowrap: true }, item.senderName)),
                                React.createElement(Stack, { horizontal: true },
                                    item.subjectIcon != null && (React.createElement(Icon, { className: _classNames.icon, iconName: item.subjectIcon })),
                                    React.createElement("h3", { id: _subjectId, className: subjectTextStyle }, item.subjectHeader))),
                            React.createElement(Text, { className: timeDeliveredStyle, nowrap: true },
                                React.createElement("span", { className: _classNames.timeHook }, this._getTimeStamp(item.timeDelivered))))),
                    React.createElement("div", { className: _classNames.contextMenuContainer },
                        React.createElement(IconButton, { className: _classNames.contextButton, ariaLabel: (_a = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.moreActionsAriaLabel) !== null && _a !== void 0 ? _a : 'More actions', menuIconProps: {
                                iconName: 'More',
                                style: { fontSize: 16 }
                            }, onKeyPress: function (event) {
                                event.stopPropagation();
                            }, menuProps: {
                                items: [
                                    {
                                        key: 'dismiss',
                                        text: (_b = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.dismiss) !== null && _b !== void 0 ? _b : 'Dismiss',
                                        onClick: function () {
                                            return _this._updateNotificationItem(item.itemKey, 'dismiss');
                                        }
                                    },
                                    {
                                        key: 'toggleReadUnread',
                                        text: item.status === 'unread'
                                            ? ((_c = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.markAsRead) !== null && _c !== void 0 ? _c : 'Mark as read')
                                            : ((_d = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.markAsUnread) !== null && _d !== void 0 ? _d : 'Mark as unread'),
                                        onClick: function () {
                                            return item.status === 'unread'
                                                ? _this._updateNotificationItem(item.itemKey, 'old', 'read')
                                                : _this._updateNotificationItem(item.itemKey, 'old', 'unread');
                                        }
                                    }
                                ]
                            } })),
                    React.createElement(Stack, { className: _classNames.additionalContent },
                        item.eventTimeBlock && (React.createElement(Text, { nowrap: true }, item.eventTimeBlock)),
                        item.eventLocation && (React.createElement(Text, { nowrap: true }, item.eventLocation)),
                        item.summaryBodyText ? (React.createElement(Text, { className: _classNames.messageBody }, this._trimMessageBodyText(item.summaryBodyText))) : item.messageBodyText ? (React.createElement(Text, { className: _classNames.messageBody }, this._trimMessageBodyText(item.messageBodyText))) : null,
                        React.createElement("div", null,
                            item.messageBodyText && (React.createElement(Link, { "aria-label": (_e = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.readMore) !== null && _e !== void 0 ? _e : 'Read More', className: _classNames.readMoreText, href: 'javascript:void(0)', onClick: this.props.showNotificationList }, (_f = itemActionsText === null || itemActionsText === void 0 ? void 0 : itemActionsText.readMore) !== null && _f !== void 0 ? _f : 'Read More')),
                            item.actionRequiredLink &&
                                item.actionRequiredText && (React.createElement(Link, { "aria-label": (((_g = item.senderName) === null || _g === void 0 ? void 0 : _g.concat(' ')) ||
                                    '') +
                                    item.subjectHeader +
                                    ' ' +
                                    item.actionRequiredText, className: _classNames.attentionText, href: item.actionRequiredLink, onClick: this._actionTextClicked }, item.actionRequiredText))))))));
    };
    return CoherenceNotificationItemBase;
}(React.Component));
export { CoherenceNotificationItemBase };
//# sourceMappingURL=CoherenceNotificationItem.base.js.map